/**
 * @module auth
 */

const state = {
  user: null
}

const getters = {
  isLogined (state) {
    return !!state.user
  }
}

const mutations = {
  login (state, payload) {
    state.user = payload
  },
  logout (state) {
    state.user = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
